import { Component, forwardRef, Input } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { GungTextInputComponent } from '../gung-text-input/gung-text-input.component';

@Component({
    selector: 'lib-gung-text-area-input-horizontal',
    templateUrl: './gung-text-area-input-horizontal.component.html',
    styleUrls: ['./gung-text-area-input-horizontal.component.css'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => GungTextAreaInputHorizontalComponent),
            multi: true
        }
    ],
    standalone: false
})
export class GungTextAreaInputHorizontalComponent extends GungTextInputComponent {
  @Input()
  public labelClass: string | string[];

  @Input()
  public rowsNumber: number;
}
